import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Button } from 'reactstrap';

/* Components */
import { DrawerCloseButton } from 'site-modules/shared/components/drawer/drawer-close-button/drawer-close-button';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';
import { mobileHeader } from 'site-modules/shared/components/clipped-container/mask-library/dealership-header';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';

import './contact-seller-button-with-drawer.scss';

export function ContactSellerButtonWithDrawer({
  toggleContactSellerDrawer = noop,
  isOpenContactSellerDrawer = false,
  isPrimary = false,
  children,
}) {
  return (
    <>
      <Button
        size="lg"
        color={isPrimary ? 'blue-50' : 'outline-primary-b'}
        className="p-0_5 text-transform-none w-100 fw-medium"
        onClick={toggleContactSellerDrawer}
      >
        <span>Send Message</span>
      </Button>
      <DrawerV2
        unmountOnExit
        classNames={{
          drawerContent: 'border-0 bg-cool-gray-90',
          drawerContainer: 'border-0 shadow-none',
        }}
        side="right"
        isOpen={isOpenContactSellerDrawer}
        toggle={toggleContactSellerDrawer}
      >
        <DrawerCloseButton onClick={toggleContactSellerDrawer} className="close-button pos-a" smBtnClass="text-white" />
        <div className="children-container d-flex rounded-20 m-1 p-1 bg-white">{children}</div>
        <ClippedContainer
          mask={mobileHeader}
          containerClasses="contact-seller-drawer-bg w-100 pos-a top-0 left-0 d-md-none"
        />
      </DrawerV2>
    </>
  );
}

ContactSellerButtonWithDrawer.propTypes = {
  toggleContactSellerDrawer: PropTypes.func,
  isOpenContactSellerDrawer: PropTypes.bool,
  isPrimary: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
